export default "__VITE_ASSET__f675e792__"